<template>
    <b-form-group class="field">
        <b-row>
            <b-col cols="12" v-if="builder">
                <b-card>
                    <b-row>
                        <b-col cols="8">
                            <template>
                                <b-form-group id="field_label" label="Título de pregunta: *" label-for="field_label">
                                    <b-form-input
                                        v-model="field_label"
                                        size="md"
                                        type="text"
                                        placeholder="Título de la Pregunta"
                                        name="field_label"
                                        id="field_label"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </template>
                        </b-col>
                        <b-col cols="12">
                            <template v-if="unique_select || multiple_select">
                                <small>Opciones:</small>
                                <b-row v-for="(option, index) in field_options" :key="index">
                                    <b-col cols="auto" v-show="option.order > -1">
                                        <b-tag class="dynamic_field_tag" @remove="removeTag(index)">
                                            {{ option.value }}
                                        </b-tag>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-3">
                                    <b-col cols="5">
                                        <b-form-input
                                            v-model="field_option_text"
                                            ref="field_option_text"
                                            size="sm"
                                            type="text"
                                            placeholder="Título de la Opción"
                                            name="field_option_text"
                                            id="field_option_text"
                                        >
                                        </b-form-input>
                                    </b-col>
                                    <b-col>
                                        <b-button :disabled="!field_option_text" size="sm" variant="info" @click="addOption()">+ Agregar</b-button>
                                    </b-col>
                                </b-row>
                            </template>
                        </b-col>
                        <b-col cols="4" style="padding-top: 15px">
                            <slot name="toolbar"></slot>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
            <b-col :cols="12" v-else>
                <slot name="label">
                    <label class="field_label">{{ field_label }}<small v-if="required">*</small></label>
                </slot>
                <template v-if="['text', 'email', 'phone'].includes(type)">
                    <b-form-input :id="getId" v-model="value" :type="type" :required="isRequired" :placeholder="placeholder"></b-form-input>
                </template>
                <!-- <b-form-select
                    v-if="unique_select"
                    :id="getId"
                    v-model="value"
                    :type="type"
                    :options="validOptions"
                    :required="isRequired"
                ></b-form-select> -->
                <b-form-group>
                    <b-form-radio-group v-if="unique_select" v-model="value" :options="validOptions" stacked :required="isRequired"></b-form-radio-group>
                </b-form-group>
                <b-form-checkbox-group v-if="multiple_select" v-model="select_value" stacked>
                    <b-form-checkbox v-for="(option, index) in validOptions" :key="index" :value="option.value">
                        {{ option.text }}
                    </b-form-checkbox>
                </b-form-checkbox-group>
                <span v-if="is_empty_option"> Por favor agregar opciones. </span>
            </b-col>
        </b-row>
    </b-form-group>
</template>

<script>
export default {
    props: {
        id: Number,
        type: {
            type: String,
            default: 'text',
        },
        label: {
            type: String,
            default: '¿Pregunta?',
        },
        answers: {
            type: Array,
            default: () => {
                return []
            },
        },
        required: {
            type: Number,
            default: 1,
        },
        placeholder: {
            type: String,
            default: '',
        },
        builder: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        value: '',
        field_label: '',
        select_value: [],
        input_options: '',
        field_options: [],
        field_option_text: '',
    }),
    computed: {
        isRequired() {
            return !!this.required
        },
        getId() {
            return 'dynamic_field_' + this.id.toString()
        },
        unique_select() {
            return ['unique_select'].includes(this.type)
        },
        multiple_select() {
            return ['multiple_select'].includes(this.type)
        },
        is_empty_option() {
            return this.builder && (this.unique_select || this.multiple_select) && this.field_options.length == 0
        },
        getTypeQuestion() {
            if (this.unique_select) {
                return 'de opción única'
            }
            if (this.multiple_select) {
                return 'de opción multiple'
            }
            return 'abierta'
        },
        validOptions() {
            return this.field_options.filter((item) => item.order !== -1)
        },
    },
    methods: {
        addOption() {
            this.field_options.push({
                value: this.field_option_text,
                text: this.field_option_text,
                order: this.field_options.length,
            })
            this.field_option_text = ''
            this.$refs.field_option_text.$el.focus()
        },
        removeTag(index) {
            this.field_options[index].order = -1
        },
    },
    watch: {
        value(val) {
            this.$emit('input', [val])
        },
        select_value(val) {
            this.$emit('input', val)
        },
        field_options(val) {
            this.$emit('changeOptions', { id: this.id, options: val })
        },
        field_label(val) {
            this.$emit('changeLabel', { id: this.id, label: val })
        },
    },
    created() {
        this.field_label = this.label
        this.field_options = this.answers
    },
}
</script>

<style scoped>
.filed {
    position: relative;
}

.field_label--builder {
    border-color: #bbb;
    border-radius: 5px;
}

.dynamic_field_tag {
    background-color: #ffffff;
    color: #6e707e;
    font-size: 1rem;
}
</style>
